import Config from 'conf';
import bindSocketSDM17SPGEvents from './binds';

export default socketMiddleware => {
    bindSocketSDM17SPGEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        FHEProductCheckStatus: function(product_type, product_identifier) {
            return new Promise((resolve, reject) => {
                let fheProductCheckStatusFeedback = args => {
                    if (product_type === args.product_type && product_identifier === args.product_identifier) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductStatus', fheProductCheckStatusFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('fheProductStatus', fheProductCheckStatusFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductCheckStatusFeedback', fheProductCheckStatusFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductCheckStatus', { product_type, product_identifier });
            });
        },
        FHEProductRemove: function(product_type, product_identifier) {
            return new Promise((resolve, reject) => {
                let fheProductRemoveFeedback = args => {
                    if (product_type === args.product_type && product_identifier === args.product_identifier) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductRemoveFeedback', fheProductRemoveFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('fheProductRemoveFeedback', fheProductRemoveFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductRemoveFeedback', fheProductRemoveFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductRemove', { product_type, product_identifier });
            });
        },
        FHEProductMasterSwitch: function(product_type, product_identifier, master_id) {
            return new Promise((resolve, reject) => {
                let fheProductMasterSwitchFeedback = args => {
                    if (product_type === args.product_type && product_identifier === args.product_identifier && master_id === args.master_id) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductMasterSwitchFeedback', fheProductMasterSwitchFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('fheProductMasterSwitchFeedback', fheProductMasterSwitchFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductMasterSwitchFeedback', fheProductMasterSwitchFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductMasterSwitch', { product_type, product_identifier, master_id });
            });
        },
        FHEProductDissociateUser: function(product_type, product_identifier, user_id) {
            return new Promise((resolve, reject) => {
                let fheProductDissociateUserFeedback = args => {
                    if (product_type === args.product_type && product_identifier === args.product_identifier && user_id === args.user_id) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductDissociateUserFeedback', fheProductDissociateUserFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('fheProductDissociateUserFeedback', fheProductDissociateUserFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductDissociateUserFeedback', fheProductDissociateUserFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductDissociateUser', { product_type, product_identifier, user_id });
            });
        },
        FHEProductDissociateUserAndSwitchMaster: function(product_type, product_identifier, user_id, master_id) {
            return new Promise((resolve, reject) => {
                let fheProductDissociateUserAndSwitchMasterFeedback = args => {
                    if (
                        product_type === args.product_type &&
                        product_identifier === args.product_identifier &&
                        user_id === args.user_id &&
                        master_id === args.master_id
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductDissociateUserAndSwitchMasterFeedback', fheProductDissociateUserAndSwitchMasterFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('fheProductDissociateUserAndSwitchMasterFeedback', fheProductDissociateUserAndSwitchMasterFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductDissociateUserAndSwitchMasterFeedback', fheProductDissociateUserAndSwitchMasterFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductDissociateUserAndSwitchMaster', { product_type, product_identifier, user_id, master_id });
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/fhepool/eventsSocket/FHEProduct/index.js